import { getShops } from 'admin/actions/shops';
import { getUser, updateUser } from 'admin/actions/user';
import ApiResult from 'admin/components/shared/ApiResult';
import Button from 'admin/components/shared/Button';
import Input from 'admin/components/shared/Input';
import { allAllowed, shopRoles } from 'admin/routes';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CSSModules from 'react-css-modules';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import Select from 'react-select';
import { bindActionCreators } from 'redux';
import Breadcrumb from '../../shared/Breadcrumb';
import styles from './styles.scss';

const modalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
  },
};

class UpdateUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {
        id: '',
        role: '',
        shops: [],
      },
      formData: {
        name: '',
        role: '',
        shops: [],
      },
      selectedRoleOption: null,
      selectedShopOption: [],
      isModalOpen: false,
      isError: false,
      apiResult: '',
    };
  }

  componentWillMount() {
    this.fetchUser();
    this.props.getShops('per_page=5000');
  }

  onConfirm() {
    this.closeModal();
    const selectedRole = this.state.selectedRoleOption.value;
    const selectedShops = this.hasShop(selectedRole)
      ? this.state.selectedShopOption.map((shop) => shop.value)
      : [];
    this.setFormData('role', selectedRole);
    this.setFormData('shops', selectedShops);
    updateUser(this.state.user.id, this.state.formData).then((response) => {
      if (response.ok) {
        this.setState({
          apiResult: '管理ユーザの更新に成功しました。',
          isError: false,
        });
        if (this.isLoginUser()) {
          location.href = '/logout';
        }
      } else {
        const statusDescription = {
          403: 'この管理ユーザに対する編集権限がありません。',
          404: '管理ユーザが存在しません。',
        };
        response.json().then((json) => {
          const errorDescription = {
            shop_admin_user_requires_shop:
              '店舗管理ユーザは少なくとも1つの管理店舗を持つ必要があります。',
            not_shop_admin_user_must_not_be_linked_to_any_shops:
              '店舗管理ユーザ以外は店舗と紐付けられません。',
          };
          this.setState({
            apiResult:
              response.status === 400
                ? errorDescription[json.type]
                : statusDescription[response.status],
            isError: true,
          });
        });
      }
      this.flashApiResult();
    });
  }

  onChangeRoleSelector(selectedRoleOption) {
    this.setState({
      selectedRoleOption,
    });
  }

  onChangeShopSelector(selectedShopOption) {
    this.setState({
      selectedShopOption,
    });
  }

  setFormData(property, value) {
    const formData = this.state.formData;
    formData[property] = value;
    this.setState({ formData: formData });
  }

  selectableRoles() {
    const pos = allAllowed.indexOf(this.props.user.role);
    return allAllowed.slice(pos);
  }

  isVisibleShopSelector() {
    if (this.state.user.role) {
      if (this.state.selectedRoleOption === null) {
        return this.hasShop(this.state.user.role);
      } else {
        return this.hasShop(this.state.selectedRoleOption.value);
      }
    } else {
      return false;
    }
  }

  hasShop(role) {
    return shopRoles.indexOf(role) >= 0;
  }

  flashApiResult() {
    setTimeout(() => this.setState({ apiResult: '' }), 5000);
  }

  openModal() {
    this.setState({ isModalOpen: true });
  }

  closeModal() {
    this.setState({ isModalOpen: false });
  }

  loginUserMessage() {
    return this.isLoginUser() ? (
      <div styleName="modal-alert">
        <p>
          ログイン中のユーザの権限を変更しようとしています。
          実行すると管理画面からログアウトします。
          より低い権限に変更するとこのユーザからの操作では上位の権限には変更できなくなります。
        </p>
      </div>
    ) : null;
  }

  isLoginUser() {
    return this.props.user.id === this.props.match.params.id;
  }

  fetchUser() {
    getUser(this.props.match.params.id).then((json) =>
      this.setState({
        user: json,
        formData: { name: json.name },
        selectedRoleOption: { label: json.role, value: json.role },
        selectedShopOption: json?.shops?.map((shop) => ({ label: shop.name, value: shop.id })),
      })
    );
  }

  modalBody() {
    return (
      <div styleName="modal-body">
        <p>以下の内容で更新してよろしいですか？</p>
        {this.loginUserMessage()}
        <table>
          <tbody>
            <tr>
              <td>変更前の名前</td>
              <td>{this.state.user.name}</td>
            </tr>
            <tr>
              <td>変更後の名前</td>
              <td>{this.state.formData.name}</td>
            </tr>
            <tr>
              <td>メールアドレス</td>
              <td>{this.state.user.email}</td>
            </tr>
            <tr>
              <td>変更前の管理権限</td>
              <td>{this.state.user.role}</td>
            </tr>
            <tr>
              <td>変更後の管理権限</td>
              <td>{this.state.selectedRoleOption ? this.state.selectedRoleOption.value : null}</td>
            </tr>
            {this.isVisibleShopSelector() ? (
              <tr>
                <td>変更前の管理店舗</td>
                <td>{this.state.user.shops.map((shop) => shop.name).join(', ')}</td>
              </tr>
            ) : null}
            {this.isVisibleShopSelector() ? (
              <tr>
                <td>変更後の管理店舗</td>
                <td>{this.state.selectedShopOption.map((shop) => shop.label).join(', ')}</td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const roleOptions = this.selectableRoles().map((role) => ({ label: role, value: role }));
    const shopOptions = this.props.shops.rows.map((row) => ({ label: row.name, value: row.id }));
    const crumb = [
      { value: 'ホーム', href: '/', active: false },
      { value: '各種設定', href: '', active: true },
      { value: '管理ユーザ設定', href: '/settings/admin-users', active: false },
      { value: '編集', href: '', active: true },
    ];
    return (
      <div>
        <Breadcrumb items={crumb} />
        <div styleName="headline">管理ユーザを編集</div>
        <div>
          <row styleName="row">
            <div styleName="label">名前</div>
            <div styleName="form-item">
              <Input
                value={this.state.formData.name}
                onChange={(e) => this.setFormData('name', e.target.value)}
                maxLength="256"
                required
              />
            </div>
          </row>
          <row styleName="row">
            <div styleName="label">メールアドレス</div>
            <div styleName="form-item">{this.state.user.email}</div>
          </row>
          <row styleName="row">
            <div styleName="label">管理権限</div>
            <div styleName="form-item">
              <Select
                id="roleSelector"
                options={roleOptions}
                onChange={this.onChangeRoleSelector.bind(this)}
                value={this.state.selectedRoleOption}
              />
            </div>
          </row>
          {this.isVisibleShopSelector() ? (
            <div>
              <row styleName="row">
                <div styleName="label">管理店舗</div>
                <div styleName="form-item">
                  <Select
                    id="shopSelector"
                    options={shopOptions}
                    isMulti="true"
                    onChange={this.onChangeShopSelector.bind(this)}
                    value={this.state.selectedShopOption}
                  />
                </div>
              </row>
            </div>
          ) : null}
          <Button onClick={this.openModal.bind(this)}>更新</Button>
          <ApiResult message={this.state.apiResult} isError={this.state.isError} />
        </div>

        <Modal
          isOpen={this.state.isModalOpen}
          onRequestClose={this.closeModal.bind(this)}
          shouldCloseOnOverlayClick={true}
          closeTimeoutMS={200}
          ariaHideApp={false}
          style={modalStyles}
        >
          {this.modalBody()}
          <div styleName="button-group">
            <Button onClick={this.closeModal.bind(this)} color="gray">
              キャンセル
            </Button>
            <Button onClick={this.onConfirm.bind(this)} color="danger">
              実行
            </Button>
          </div>
        </Modal>
      </div>
    );
  }
}

UpdateUser.propTypes = {
  getShops: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  shops: state.shop.shops,
  user: state.user,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ getShops }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(UpdateUser, styles));
